<template>
  <div class="flex rounded-full items-center">
    <slot> </slot>
  </div>
</template>
